import { Buton, FiltreKarti, Ikon, Kart } from "@koclukpanel/ui";
import { SayfaBasligiEki } from "./Kabuk";
import { OgrenciSecimAlani } from "./OgrenciSecici";

/**
 * HAFTALIK PROGRAM GİRİŞİ — UNİKOÇ "Haftalık Ders Programı" (sürüm 9a L2; WeeklySchedule-Index)
 *
 * Eski panelde giriş bir öğrenci LİSTESİ değildi: bant, altında "Seçimler" kartı
 * (Öğrenci açılır listesi + "Atanmış öğrencileriniz listelendi."), altında "Mevcut
 * Haftalar" başlığı. Öğrenci seçilince program ekranı (Program.tsx) açılır; haftalar
 * orada listeleniyor, burada değil — seçimden önce gösterilecek hafta yok.
 *
 * "Bekleyen işlerden seç" korunuyor (F-ANL-09): iş listesi, bekleyen işi olan
 * öğrenciyi bulmanın en hızlı yolu; UNİKOÇ'ta yoktu, kaldırmak işlev kaybı olurdu.
 */
export function ProgramGirisi({
  onSec,
  onIsListesi,
}: {
  onSec: (id: string, ad: string) => void;
  onIsListesi?: () => void;
}) {
  return (
    <div className="flex flex-col gap-6">
      <SayfaBasligiEki aciklama="Öğrenciyi seçip haftalık ders programlarını yönetin." />
      <FiltreKarti
        baslik="Seçimler"
        ikon="ogrenci"
        eylemler={
          onIsListesi ? (
            <Buton gorunum="kesikli" onClick={onIsListesi}>
              <Ikon ad="bugun" boyut="kucuk" /> Bekleyen işlerden seç
            </Buton>
          ) : undefined
        }
      >
        <div className="max-w-xl">
          <OgrenciSecimAlani
            secili={null}
            onSec={onSec}
            yardim="Atanmış öğrencileriniz listelendi."
          />
        </div>
      </FiltreKarti>

      <section aria-labelledby="mevcut-haftalar" className="flex flex-col gap-3">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h2
            id="mevcut-haftalar"
            className="text-metin-koyu flex items-center gap-2 text-xl font-bold md:text-2xl"
          >
            <Ikon ad="gorevler" className="text-metin-koyu size-6" />
            Mevcut Haftalar
          </h2>
          <p className="text-metin-ikincil flex items-center gap-1.5 text-sm">
            <Ikon ad="bilgi" className="size-4" />
            Kartlara tıklayarak hızlı işlem yapabilirsiniz.
          </p>
        </div>
        <Kart gorunum="unk" olarak="div">
          <p className="text-metin-koyu text-sm md:text-base">
            Haftaları görmek için yukarıdan öğrenci seçin.
          </p>
        </Kart>
      </section>
    </div>
  );
}
